import MuiRadio from '@mui/material/Radio';
import { forwardRef } from 'react';
import { Props } from './types';
import { StyledCheckedRadioIcon, StyledRadioIcon } from './styles';
import CONFIG from './config';

const Radio = forwardRef<HTMLButtonElement, Props>(
  ({ size = CONFIG.DEFAULT_SIZE, ...otherProps }, ref) => {
    return (
      <MuiRadio
        ref={ref}
        {...otherProps}
        size="small" //? for now we are using only small size
        checkedIcon={<StyledCheckedRadioIcon size="small" />} //? for now we are using only small size
        icon={<StyledRadioIcon size="small" />}
      />
    );
  },
);

Radio.displayName = 'Radio';

export default Radio;
